<template>
  <v-dialog
    :value="waitDownloadDialog"
    @input="close"
    max-width="500px">
    <v-card class="px-4 pt-4 pb-2">
      <v-card-text>
				<v-layout column xs12 text-xs-center>
					<v-flex mb-3>
						<v-icon large class="k-orange-linear-text lighten-1">
							fas fa-check-double
						</v-icon>
					</v-flex>
					<v-flex>
						Se esta generando su archivo, se le informara cuando este listo. <br/> Por favor espere.
					</v-flex>
				</v-layout>
      </v-card-text>
      <v-card-actions class="pr-2">
        <v-spacer></v-spacer>
        <v-btn color="black darken-1" flat @click="close(false)">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'waitDownloadDialog',
    ]),
  },
  methods: {
    close(value) {
      this.$store.commit('SET_WAIT_DOWNLOAD_DIALOG', value);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/global/StartDownloadModal.vue